import { Component, Input } from '@angular/core';
import { isNullOrUndefined } from '@pineapplelab/util';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent {
  @Input() avatar: string = null;
  @Input() borderRadius?: number = 40; //In % is the value
  @Input() width?: number = 40;
  @Input() height?: number = 40;

  constructor() { }

}
